import { createSlice } from "@reduxjs/toolkit";
import {
  getMetaDetailsByPathname,
  createMetaDetails,
  updateMetaDetails,
} from "actions/metaDetails";

const initialState = {
  loading: false,
  updateLoading: false,
  metaDetails: null,
  error: null,
};

const metaDetailsSlice = createSlice({
  name: "metaDetails",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearMetaDetails: (state) => {
      state.metaDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMetaDetailsByPathname.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMetaDetailsByPathname.fulfilled, (state, action) => {
        state.loading = false;
        state.metaDetails = action.payload;
      })
      .addCase(getMetaDetailsByPathname.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createMetaDetails.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(createMetaDetails.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.metaDetails = action.payload;
      })
      .addCase(createMetaDetails.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
      })

      .addCase(updateMetaDetails.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateMetaDetails.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.metaDetails = action.payload;
      })
      .addCase(updateMetaDetails.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearMetaDetails } = metaDetailsSlice.actions;
export default metaDetailsSlice.reducer;
